var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntersection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H15C15.9665 1.25 16.75 2.0335 16.75 3V7.25H21C21.9665 7.25 22.75 8.0335 22.75 9V21C22.75 21.9665 21.9665 22.75 21 22.75H9C8.0335 22.75 7.25 21.9665 7.25 21V16.75H3C2.0335 16.75 1.25 15.9665 1.25 15V3ZM15.25 3C15.25 2.86193 15.1381 2.75 15 2.75H3C2.86193 2.75 2.75 2.86193 2.75 3V15C2.75 15.1381 2.86193 15.25 3 15.25H7.25V9C7.25 8.0335 8.0335 7.25 9 7.25H15.25V3ZM15 16.75H8.75V21C8.75 21.1381 8.86193 21.25 9 21.25H21C21.1381 21.25 21.25 21.1381 21.25 21V9C21.25 8.86193 21.1381 8.75 21 8.75H16.75V15C16.75 15.9665 15.9665 16.75 15 16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection);
export default __webpack_public_path__ + "static/media/intersection.de25576614252f6e0778f28dda459864.svg";
export { ForwardRef as ReactComponent };